export default __webpack_public_path__ + "images/E6.af5cbf5.png";